<template>
    <data-container class="band-list-container">
        <template slot="controls">
            <search-field @input="search"></search-field>

            <div class="control-wrapper">

                <div class="controls">
                    <!-- <custom-option
                        :options="filterOptions"
                        placeholder="Filter by"
                        v-model="params.filterBy"
                    >
                    </custom-option> -->

                    <custom-option
                        :options="sortOptions"
                        placeholder="Sort by"
                        v-model="params.sortBy"
                    >
                    </custom-option>
                </div>
                <div></div>

                <div class="controls">                    
                    <button
                        class="_deny"
                        :disabled="selected.length < 1 || buttonLoading"
                        @click="removeBands"
                    >
                        Remove
                    </button>
                </div>
            </div>
        </template>

        <template slot="content">
            <custom-table
                key-field="macAddress"
                :fields="fields"
                :items="bandList"
                :has-pagination="true"
                :isLoading="false"
                :class="{'disable': false}"
                is-selectable
                :selected-items="selected"
                :currentPage="1"
                :totalCount="bandList.length || 0"
                :itemsPerPage="bandList.length || 0"
                hidePerPageOption                
            >
                <template slot="created_at" slot-scope="{ item }">
					{{ item.created_at | dateFormatter('MMMM DD, YYYY') }}
                </template>

                <template slot="actions" slot-scope="{ item }">
                    <button
						class="_deny"
						@click="remove(item)"
						:disabled="buttonLoading"
					>Remove</button>
                </template>
            </custom-table>
        </template>
	</data-container>
</template>

<script>
import DataContainer from '@/components/layouts/DataContainer.vue'
import CustomTable from '@/components/utils/CustomTable.vue'
import SearchField from '@/components/utils/SearchField.vue'
import CustomOption from '@/components/utils/CustomOption.vue'
import RouterFormValidation from '@/mixins/router-form-validation.js'

export default {
    props: ['id'],
    
    computed: {
		bands () {
			return this.formData
					.bands.filter(band => band.macAddress.trim() !== '' ||
								band.name.trim() !== '')
		},

        bandList () {
			let bands
            if (this.keyword) {
                bands = this.filteredBands.slice().sort((band1, band2) => {
					if (this.params.sortBy === 'Oldest') {
						return new Date(band1.created_at) - new Date(band2.created_at)
					}

					return new Date(band2.created_at) - new Date(band1.created_at)
				})
			} else {
				bands = this.bands.slice().sort((band1, band2) => {
							if (this.params.sortBy === 'Oldest') {
								return new Date(band1.created_at) - new Date(band2.created_at)
							}
						return new Date(band2.created_at) - new Date(band1.created_at)
					})
			}


			return bands
        }
    },

	data () {
		return {
            filteredBands: [],
            keyword: '',

			fields: [
				{ name: 'id', text: 'Band ID' },
                { name: 'name', text: 'Band Name'},
				{ name: 'macAddress', text: 'Band MAC address' },
                { name: 'created_at', text: 'Date Registered' }
            ],

            params: {
				filterBy: null,
				sortBy: null
            },
            
            sortOptions: ['Latest', 'Oldest'],

			filterOptions: ['All', 'Online', 'Offline', 'For Activation'],

			selected: [],
		}
    },

    methods: {
        removeBands () {
			this.$store.commit('modal/toggleModal', {
                modalType: 'warning',
                modalName: 'confirm-modal',
				modalDesc: 'Do you want to remove this band(s)?',
				action: () => {
					this.selected.forEach(mac => {
					const index = this.formData.bands.findIndex(band => band.macAddress === mac)
						const { id } = this.formData.bands[index]
						if (id) this.deletedIds.push(id)

						this.formData.bands.splice(index, 1)
					})
		
					this.selected = []
					this.submit()
				}
			})
        },

        remove ({ macAddress }) {
			this.$store.commit('modal/toggleModal', {
                modalType: 'warning',
                modalName: 'confirm-modal',
				modalDesc: 'Do you want to remove this band(s)?',
				action: () => {
					const index = this.formData.bands
									.findIndex(band => band.macAddress === macAddress)
					const { id } = this.formData.bands[index]
					if (id) this.deletedIds.push(id)
					this.formData.bands.splice(index, 1)
					this.submit()
				}
			})
        },

        search (value) {
            this.keyword = value
            this.filteredBands = this.formData.bands.filter(band => {
				value = value.toLowerCase()
				return band.macAddress.toLowerCase().startsWith(value.trim()) ||
						band.name.toLowerCase().startsWith(value.trim())
            })
		}
	},
	
	mixins: [ RouterFormValidation ],

	components: {
        CustomTable,
        DataContainer,
		SearchField,
        CustomOption
	}
}
</script>

<style lang="scss" scope>
.band-list-container {
	height: 100%;
    width: 100%;
    padding: 20px;
    min-height: 300px;

    .custom-table {
        min-height: 600px;
    }

    .control-wrapper {
        flex: 1 1 auto;
        margin-top: 15px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        

        .controls {
            display: flex;
            justify-content: flex-end;

            > * {
                &:not(:first-child) {
                    margin-left: 10px;
                }
            }
        }
        
    }
}
</style>
